module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVAAAAAMCAMAAAADDRXTAAAAM1BMVEUAAADT09PU1NTT09PV1dXU1NTU1NTU1NTPz8/U1NTU1NTV1dXU1NTS0tLW1tbU1NTU1NS4FougAAAAEHRSTlMAIIBA4MCgcBDv0LBgYI+PIZJMaAAAAKpJREFUSMftl9sKwyAQRHeNRnNr5/+/tlQlhQylZJu37Hmah/HCAZGVxjCIY4cNjos4ZtigAkUcK2zwCQRxbLDBkiMwbfpjDYA93C3LN9ighoTOnNWFnhTKBjXP6KSg4pyGDeo6ATH7t2SFDQbgIY4VNlgAf+1/wAaXURwDbPDK0ROIbTO8aQeEmtvu8fNzKlW2mtOxkmpeqaI1UyXUPB4r/V5U2e913ej5AtMhGofRtqotAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dailyFreeCash/line.png
// module id = QGYe
// module chunks = 0